module.exports = __webpack_public_path__ + "static/course4-8dad7c1d61195012ad6dfca253caefd8.jpg";